export const FETCH_MICRO_BIOLOGY_RESULTS_REQUEST = "FETCH_MICRO_BIOLOGY_RESULTS_REQUEST";
export const FETCH_MICRO_BIOLOGY_RESULTS_SUCCESS = "FETCH_MICRO_BIOLOGY_RESULTS_SUCCESS";
export const FETCH_MICRO_BIOLOGY_RESULTS_FAILURE = "FETCH_MICRO_BIOLOGY_RESULTS_FAILURE";